export default "__VITE_ASSET__B2g1FeI6__ 400w, __VITE_ASSET__Bm3TiYSc__ 800w, __VITE_ASSET__BMpHAnfg__ 1200w";